import { render, staticRenderFns } from "./Delete.vue?vue&type=template&id=663b2372&scoped=true"
import script from "./Delete.vue?vue&type=script&lang=js"
export * from "./Delete.vue?vue&type=script&lang=js"
import style0 from "./Delete.vue?vue&type=style&index=0&id=663b2372&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "663b2372",
  null
  
)

export default component.exports